import Vue from "vue";
import i18n from "@/plugins/i18n.js";
import store from "@/store";

const pageTitle = {
  install(Vue) {
    Vue.prototype.$appPageTitle = {
      tab: function (title) {
        if (title) {
          if (store.getters.storeInfo) {
            document.title =
              i18n.t("sections." + title.toLowerCase()) +
              " - " +
              store.getters.storeInfo.storeName;
          } else {
            document.title =
              i18n.t("sections." + title.toLowerCase()) +
              " - " +
              store.getters.appInfo.appName;
          }
        }
      },
    };
  },
};
Vue.use(pageTitle);
